<template>

	<section>
		<!-- Main Section -->
		<section class="main-section cover">

			<div class="row full_h">
				<div class="columns small-12 medium-12 large-6 main-section_pad_s">
					<!-- Tabs -->
					<div class="tabs tabs_small">

						<ul class="tabs__nav-list clear_fix">
							<li class="tabs__nav-item active">
								<a href="" class="tabs__nav-link">Врачи</a>
							</li>
							<li class="tabs__nav-item">
								<a href="" class="tabs__nav-link">Клиники</a>
							</li>
						</ul>

						<ul class="tabs__list">
							<li class="tabs__item active">

								<!-- Select -->
								<div class="tabs__inner select-outer">
									<select2 class="select"
													 :options="$parent.specializations"
													 placeholder="Выберите специализацию"
													 v-model="workerSearchModel.specialization_ids"></select2>
								</div>
								<!-- Select End -->

								<!-- Checkboxes -->
								<div class="tabs__inner">
									<div class="checkbox tabs__checkbox clear_fix">

										<div class="checkbox__inner">
											<label class="checkbox__label">
												<input class="checkbox__input" type="checkbox" value="adult" v-model="workerSearchModel.type">
												<span class="checkbox__custom-input"></span>
												<span class="checkbox__text checkbox__text_white">Взрослый</span>
											</label>
										</div>

										<div class="checkbox__inner">
											<label class="checkbox__label">
												<input class="checkbox__input" type="checkbox" value="childish"
															 v-model="workerSearchModel.type">
												<span class="checkbox__custom-input"></span>
												<span class="checkbox__text checkbox__text_white">Детский</span>
											</label>
										</div>

									</div>
								</div>
								<!-- Checkboxes End -->

								<!-- Select -->
								<div class="tabs__inner select-outer">
									<select2 :options="cities" class="select"
													 placeholder="Выберите район"
													 v-model="workerSearchModel.region"
													 disabled></select2>
								</div>
								<!-- Select End -->

								<!-- Checkboxes -->
								<div class="tabs__inner">
									<div class="checkbox tabs__checkbox clear_fix">

										<div class="checkbox__inner">
											<label class="checkbox__label">
												<input class="checkbox__input" type="checkbox" value="private"
															 v-model="workerSearchModel.clinic_own_type">
												<span class="checkbox__custom-input"></span>
												<span class="checkbox__text checkbox__text_white">Частные<br> клиники</span>
											</label>
										</div>

										<div class="checkbox__inner">
											<label class="checkbox__label">
												<input class="checkbox__input" type="checkbox" value="state"
															 v-model="workerSearchModel.clinic_own_type">
												<span class="checkbox__custom-input"></span>
												<span class="checkbox__text checkbox__text_white">Гос.<br> клиники</span>
											</label>
										</div>

									</div>
								</div>
								<!-- Checkboxes End -->

								<div class="tabs__inner">
									<!--<p class="tabs__info">Найдено {{workerResult.length}}</p>-->
								</div>

								<div class="tabs__inner">
									<a @click="searchDoctor" class="tabs__btn tabs__btn_show">Показать</a>
								</div>
							</li>

							<li class="tabs__item">

								<!-- Select -->
								<div class="tabs__inner select-outer">
									<select2 class="select2"
													 :options="$parent.clinicTypes"
													 placeholder="Выберите клинику"
													 v-model="clinicSearchModel.clinic_type"></select2>
								</div>
								<!-- Select End -->

								<!-- Select -->
								<div class="tabs__inner select-outer">
									<select2 class="select"
													 :options="cities"
													 placeholder="Выберите регион"
													 v-model="clinicSearchModel.city" disabled></select2>
								</div>
								<!-- Select End -->

								<!-- Checkboxes -->
								<div class="tabs__inner">
									<div class="checkbox tabs__checkbox clear_fix">

										<div class="checkbox__inner">
											<label class="checkbox__label">
												<input class="checkbox__input" type="checkbox" value="private"
															 v-model="clinicSearchModel.own_type">
												<span class="checkbox__custom-input"></span>
												<span class="checkbox__text checkbox__text_white">Частные<br> клиники</span>
											</label>
										</div>

										<div class="checkbox__inner">
											<label class="checkbox__label">
												<input class="checkbox__input" type="checkbox" value="state"
															 v-model="clinicSearchModel.own_type">
												<span class="checkbox__custom-input"></span>
												<span class="checkbox__text checkbox__text_white">Гос.<br> клиники</span>
											</label>
										</div>

									</div>
								</div>
								<!-- Checkboxes End -->

								<div class="tabs__inner">
									<!--<p class="tabs__info">Найдено 2123</p>-->
								</div>

								<div class="tabs__inner">
									<a @click="searchClinic" class="tabs__btn tabs__btn_show">Показать</a>
								</div>
							</li>
						</ul>
					</div>
					<!-- Tabs End -->
				</div>

				<div class="columns small-12 medium-6 large-6 pos_r full_h hide-for-small hide-for-medium">

					<!-- Slider -->
					<div class="main-slider">

						<div class="main-slider__slide">
							<div class="row">
								<div class="columns small-12 medium-12 large-12">
									<div class="main-slider__content">
										<h2 class="main-slider__title">Найди хорошего врача в своем городе</h2>
										<p class="main-slider__descr">Только независимые отзывы о врачах и клиниках от их клиентов</p>
									</div>
								</div>
							</div>
						</div>

						<div class="main-slider__slide">
							<div class="row">
								<div class="columns small-12 medium-12 large-12">
									<div class="main-slider__content">
										<h2 class="main-slider__title">Запишись к нужному специалисту в пару кликов</h2>
										<p class="main-slider__descr">Система умной записи к врачам в системе</p>
									</div>
								</div>
							</div>
						</div>

						<div class="main-slider__slide">
							<div class="row">
								<div class="columns small-12 medium-12 large-12">
									<div class="main-slider__content">
										<h2 class="main-slider__title">Рекомендуй хороших специалистов другим</h2>
										<p class="main-slider__descr">Помоги другим выбрать правильного специалиста</p>
									</div>
								</div>
							</div>
						</div>

					</div>
					<!-- Slider End -->
				</div>
			</div>
			<!-- Row End -->

		</section>
		<!-- Main Section End -->

		<!-- New Doctors -->
		<section class="new-doctors section_pad">
			<div class="row">

				<div class="columns small-12 medium-12 large-12">
					<h2 class="section-title">Новые врачи сервиса в городе</h2>
				</div>

				<div class="columns small-12 medium-12 large-8">
					<!-- New Docs Main Wrap -->
					<div class="new_doctors__main-wrap">

						<doctor-thumbnail v-for="doctor in doctors" :key="doctor._id" :doctor="doctor"></doctor-thumbnail>

					</div>
					<!-- New Docs Main Wrap End -->
				</div>
				<!-- Column End -->

				<div class="columns small-12 medium-12 large-4">
					<div id="map" class="mapmain"><div class="temporary">Функционал карты временно недоступен</div></div>
				</div>

				<div class="columns small-12 medium-12 large-12">
					<div class="search-btns">

						<div class="search-btns__btn-item">
							<router-link to="doctors" class="router-link">Подобрать врача</router-link>
						</div>

						<div class="search-btns__btn-item">
							<router-link to="clinics" class="router-link">Подобрать клинику</router-link>
						</div>
					</div>
				</div>

			</div>
		</section>
		<!-- New Doctors End -->

		<!-- News --><!--
		<section class="news">
			<div class="row">
				<div class="columns small-12 medium-12 large-12">
					<h2 class="section-title">Новости</h2>
				</div>
			</div>
			<div class="news__bg-box cover section_pad">
				<div class="row row_z">
					<div class="columns small-12 medium-12 large-6">
						<h3 class="news__main-title">
							Новый сервис для контроля за вашим здоровьем
						</h3>
					</div>
					<div class="columns small-12 medium-12 large-6">

						<div class="news__wrap">

							<div class="news__item">
								<div class="news__date">01.07</div>
								<div class="news__content">
									Новый сервис для контроля за вашим здоровьем
								</div>
							</div>

							<div class="news__item">
								<div class="news__date">01.07</div>
								<div class="news__content">
									Новый сервис для контроля за вашим здоровьем
								</div>
							</div>

							<div class="news__item">
								<div class="news__date">01.07</div>
								<div class="news__content">
									Новый сервис для контроля за вашим здоровьем
								</div>
							</div>
						</div>

						<div class="news__link-wrap">
							<a href="#" class="news__link news__link_show_all bold trans">Показать все новости</a>
							<i class="news__link-icon icon ion-chevron-right"></i>
						</div>

					</div>
				</div>
			</div>
		</section>-->
		<!-- News End -->

		<appointment></appointment>

	</section>
</template>

<script>
	import 'slick-carousel'

	import Select2 from '../components/Select2.vue';
	import DoctorThumbnail from '../components/Thumbnails/DoctorThumbnail.vue';
	import Appointment from '../components/Modals/Appointment.vue';
    import Map from '@/common/Map'

	export default {
		name: "General",
		components: {Select2, DoctorThumbnail, Appointment},
		mounted() {
			this.$store.dispatch('worker/search', {per_page: 7}).then(list => this.doctors = list.users)

			$('.main-slider').slick({
				dots: true,
				arrows: false,
				infinite: true,
				speed: 800,
                autoplay: true,
                autoplaySpeed: 3000,
				slidesToShow: 1,
				slidesToScroll: 1,
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: true
					}
				}, {
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			})

			$('.tabs__nav-link').on('click', function(e) {
				e.preventDefault()

				let tabLink = $(this).closest('.tabs__nav-item'),
					tabItem = $('.tabs__item'),
					itemNumber = tabLink.index()

				// Variant 1
				tabItem.eq(itemNumber)
					.add(tabLink)
					.addClass('active')
					.siblings().removeClass('active')
			})
		},
		data() {
			return {
				workerSearchModel: {
					type: [],
					clinic_own_type: []
				},
				clinicSearchModel: {
					type: [],
					clinic_own_type: []
				},
				doctors: [],
				workerResult: {},
				clinicResult: {},
				cities: []
			}
		},
		methods: {
			searchDoctor() {
				this.$router.push({
					name: 'Doctors',
					query: this.workerSearchModel
				})
			},
			searchClinic() {
				this.$router.push({
					name: 'Clinics',
					query: this.clinicSearchModel
				})
			}
		}
	}
</script>
    
<style scoped>
	.router-link {
		color: white;
	}

	.link_black {
		color: #333;
	}

	.fix {
		text-align: center;
		line-height: 56px;
		font-size: 1.5em;
	}

	.user_fix {
		line-height: 136px;
		text-align: center;
		color: white;
		font-size: 3em;
	}
</style>

<style>
	.gray {
		background-color: #c2c2c2 !important;
		pointer-events: none;
	}
</style>



// WEBPACK FOOTER //
// General.vue?17115d85